import { Localized } from "@fluent/react"
import { Chip } from "@mui/material"

import type { DocumentTeamMemberRoleEnum } from "../documentWorkflowApi"
import { roleChipColor } from "../DocumentWorkflowConfig"
import { mapRoleFromApi } from "../documentWorkflowHelpers"
import type { TeamMemberRole, UiStageType } from "../documentWorkflowTypes"

type DocumentTeamMemberRoleChipProps = {
    role: DocumentTeamMemberRoleEnum | null
    stageType: UiStageType
}

const roleLabels: Record<TeamMemberRole, { id: string; fallback: string }> = {
    Autor: { id: "document-role-creator", fallback: "_Author" },
    Edytor: { id: "document-role-editor", fallback: "_Editor" },
    Opiniujacy: { id: "document-role-reviever", fallback: "_Reviewer" },
    Zatwierdzajacy: { id: "document-role-approver", fallback: "_Approver" },
}

export const DocumentTeamMemberRoleChip = ({
    role,
    stageType,
}: DocumentTeamMemberRoleChipProps) => {
    const mappedRole = mapRoleFromApi(role, stageType)
    const label = roleLabels[mappedRole]

    return <Chip
        size="small"
        variant="outlined"
        color={roleChipColor[mappedRole]}
        label={<Localized id={label.id}>
            <span>{label.fallback}</span>
        </Localized>}
        sx={{
            height: 30,
            flexShrink: 0,
            "& .MuiChip-label": { px: 1, fontSize: "0.78rem" },
        }}
    />
}